import { NavLink, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { http } from "@/lib/api";

/** Slim tab bar on every Science Pulse page. Pillars become the tabs. */
export default function ScienceNav() {
  const { pillar } = useParams();
  const [pillars, setPillars] = useState([]);
  useEffect(() => {
    http.get("/science/taxonomy").then(({ data }) => setPillars(data.pillars || [])).catch(() => {});
  }, []);
  return (
    <nav className="flex flex-wrap gap-1.5 mb-8" data-testid="science-nav" aria-label="Science Pulse">
      <NavLink
        to="/science" end
        data-testid="sp-nav-home"
        className={({ isActive }) =>
          "rounded-full px-3 py-1.5 font-mono-tech text-[10px] tracking-[0.22em] uppercase border transition-colors " +
          (isActive ? "bg-[#1B4332] text-[#F5EBDC] border-transparent" : "bg-white border-black/15 hover:bg-black/5")
        }
      >All science</NavLink>
      <NavLink
        to="/science/today"
        data-testid="sp-nav-today"
        className={({ isActive }) =>
          "rounded-full px-3 py-1.5 font-mono-tech text-[10px] tracking-[0.22em] uppercase border transition-colors " +
          (isActive ? "bg-[#1B4332] text-[#F5EBDC] border-transparent" : "bg-white border-black/15 hover:bg-black/5")
        }
      >Today</NavLink>
      {pillars.map((p) => (
        <NavLink
          key={p.slug}
          to={`/science/${p.slug}`}
          data-testid={`sp-nav-${p.slug}`}
          className={"rounded-full px-3 py-1.5 font-mono-tech text-[10px] tracking-[0.22em] uppercase border transition-colors " +
            (pillar === p.slug ? "bg-[#1B4332] text-[#F5EBDC] border-transparent" : "bg-white border-black/15 hover:bg-black/5")}
        >{p.emoji} {p.label}</NavLink>
      ))}
    </nav>
  );
}
